import { Navigate, Route, Routes } from 'react-router-dom';
import { AuthGate } from './components/AuthGate';
import { ErrorBoundary } from './components/ErrorBoundary';
import { Layout } from './components/Layout';
import { DashboardPage } from './pages/DashboardPage';
import { CalendarPage } from './pages/CalendarPage';
import { ClientsPage } from './pages/ClientsPage';
import { ClientDetailPage } from './pages/ClientDetailPage';
import { AppointmentDetailPage } from './pages/AppointmentDetailPage';
import { AppointmentFormPage } from './pages/AppointmentFormPage';
import { StatsPage } from './pages/StatsPage';
import { SettingsPage } from './pages/SettingsPage';
import { StockPage } from './pages/StockPage';
import { ExpensesPage } from './pages/ExpensesPage';
import { OtherIncomesPage } from './pages/OtherIncomesPage';
import { useAuthStore } from './store/auth';
import {
  ServicesSettings,
  ExtrasSettings,
  LengthsSettings,
  TagsSettings,
  CategoriesSettings,
  NotificationsSettings,
  MastersSettings,
  ProfileSettings,
} from './pages/settings';

const OwnerOnly = ({ children }: { children: React.ReactNode }) => {
  const { master } = useAuthStore();
  if (master?.role !== 'owner') return <Navigate to="/settings" replace />;
  return <>{children}</>;
};

const NonViewer = ({ children }: { children: React.ReactNode }) => {
  const { master } = useAuthStore();
  if (master?.role === 'viewer') return <Navigate to="/calendar" replace />;
  return <>{children}</>;
};

const ViewerHome = () => {
  const { master } = useAuthStore();
  if (master?.role === 'viewer') return <Navigate to="/calendar" replace />;
  return <DashboardPage />;
};

export const App = () => (
  <ErrorBoundary>
    <AuthGate>
      <Routes>
      <Route element={<Layout />}>
        <Route index element={<ViewerHome />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/clients" element={<NonViewer><ClientsPage /></NonViewer>} />
        <Route path="/clients/:id" element={<NonViewer><ClientDetailPage /></NonViewer>} />
        <Route path="/appointments/new" element={<NonViewer><AppointmentFormPage mode="create" /></NonViewer>} />
        <Route path="/appointments/:id" element={<AppointmentDetailPage />} />
        <Route path="/appointments/:id/edit" element={<NonViewer><AppointmentFormPage mode="edit" /></NonViewer>} />
        <Route path="/appointments/:id/reschedule" element={<NonViewer><AppointmentFormPage mode="reschedule" /></NonViewer>} />
        <Route path="/stats" element={<NonViewer><StatsPage /></NonViewer>} />
        <Route path="/stock" element={<NonViewer><StockPage /></NonViewer>} />
        <Route path="/expenses" element={<NonViewer><ExpensesPage /></NonViewer>} />
        <Route path="/other-incomes" element={<NonViewer><OtherIncomesPage /></NonViewer>} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/settings/services" element={<OwnerOnly><ServicesSettings /></OwnerOnly>} />
        <Route path="/settings/extras" element={<OwnerOnly><ExtrasSettings /></OwnerOnly>} />
        <Route path="/settings/lengths" element={<OwnerOnly><LengthsSettings /></OwnerOnly>} />
        <Route path="/settings/tags" element={<OwnerOnly><TagsSettings /></OwnerOnly>} />
        <Route path="/settings/expense-categories" element={<OwnerOnly><CategoriesSettings /></OwnerOnly>} />
        <Route path="/settings/notifications" element={<NotificationsSettings />} />
        <Route path="/settings/masters" element={<OwnerOnly><MastersSettings /></OwnerOnly>} />
        <Route path="/settings/profile" element={<ProfileSettings />} />
        </Route>
      </Routes>
    </AuthGate>
  </ErrorBoundary>
);
